import { CXRoleplayBase } from '@/components/cx/CXRoleplayBase';
import { getScenarioByCompany, cxScenarios } from '@/config/cx-scenarios';
import { useParams, Navigate, useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

export function CXRoleplayWrapper() {
  const { companyCode } = useParams<{ companyCode: string }>();
  const [searchParams] = useSearchParams();

  // Get engine from URL params, validate it, default to null (which will use elevenlabs)
  const engine = useMemo(() => {
    const engineParam = searchParams.get('engine') as
      | 'elevenlabs'
      | 'livekit'
      | null;
    return engineParam && ['elevenlabs', 'livekit'].includes(engineParam)
      ? engineParam
      : null;
  }, [searchParams]);

  if (!companyCode) {
    return <Navigate to="/404" replace />;
  } else {
    console.log('companyCode:', companyCode);
    console.log('All available scenarios:', Object.keys(cxScenarios));
  }

  const scenario = getScenarioByCompany(companyCode);

  if (!scenario) {
    // If scenario doesn't exist, show 404
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Company not found
          </h1>
          <p className="text-gray-600">
            No roleplay scenario found for company: {companyCode}
          </p>
        </div>
      </div>
    );
  }

  // Use scenario code (which is same as companyCode for now) for API paths
  const scenarioCode = companyCode;

  return (
    <CXRoleplayBase
      scenario={scenario}
      scenarioCode={scenarioCode}
      apiBasePath={`api/cx/scenarios/${scenarioCode}`}
      assessmentPath={`/cx/${scenarioCode}/roleplay/{sessionId}/assessment`}
      engine={engine}
    />
  );
}
